import _ from 'lodash';
import React, { FC } from 'react';
import { Form } from 'antd';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import { Option, Select } from '../../../system/components/Select';

interface Props {
  form: WrappedFormUtils;
  initialValue?: number;
}

export const SelectMinAgeAllowed: FC<Props> = ({ form, initialValue }): JSX.Element => (
  <Form.Item
    label="Minimum patient age"
    extra="Sets a minimum age restriction of the patient. This profile will not show up in search results if the patient age does not meet the minimum age restriction."
  >
    {form.getFieldDecorator('onlyAllowsAgeMin', {
      initialValue: initialValue ? initialValue : '',
      rules: [],
    })(
      <Select allowClear>
        <Option value={''} key="minAge-noMin">
          No Min
        </Option>
        {_.range(0, 99).map(age => (
          <Option value={age} key={`minAge-${age}`}>
            {age.toString()}
          </Option>
        ))}
      </Select>
    )}
  </Form.Item>
);
